// import l from '@/vendor/logger'

export const numToKor = (
  num,
  prefix = '',
  suffix = ''
) => {
  const korNums = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구', '십']
  const korUnits = ['', '십', '백', '천', '', '십', '백', '천', '', '십', '백', '천', '', '십', '백', '천']
  let numString
  let result = ''

  num
    ? isNaN(num)
      ? numString = 0 : num === true
        ? numString = 0 : numString = Math.round(num).toString()
    : numString = 0

  let len = numString.length

  for (let i = 0; i < len; i++) {
    let base = ''
    let kor = korNums[numString.charAt(len - (i + 1))]
    if (kor !== '') { base += kor + korUnits[i] }
    if (i === 4) { base += '만' }
    if (i === 8) { base += '억' }
    if (i === 12) { base += '조' }
    result = base + result
  }
  return prefix + result + suffix
}

export default {
  methods: {
    numToKor
  }
}
